module.exports = __webpack_public_path__ + "img/shibai.65dbeef2.png";